// extracted by mini-css-extract-plugin
module.exports = {"scopeCell":"style-module_scopeCell__j1bNfqK_nBoI3FBL3aFU","defineScope":"style-module_defineScope__NfJfCcOjG1FkabUPaqMQ"};